import { useEffect, useState } from "react";
import { useAppServices } from "../../hook/services";
import localforage from "localforage";
import { useUserInfo } from "../../context/user";
import maybeLogo from "../../assets/icons/maybe-icon.png";
import { useLocation, useNavigate } from "react-router-dom";
import AuthTopBar from "../authentication/component/AuthTopBar";
import Icons from "../../components/icons"
import ForgetModel from "../authentication/component/ForgetModel";


const SetPassword = () => {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get("token");
  const Service = useAppServices();
  const [whitelabel, setwhitelabel] = useState([]);
  const [loading, setLoading] = useState(false);
  const [messages, setmessages] = useState("");
  const navigate = useNavigate();
  const agencyData = useUserInfo()[11];
  const [tokenStatus, setTokenStatus] = useState(true);
  const [openForgetModel, setOpenForgetModel] = useState(false);
  const [fieldType, setFieldType] = useState({ password: "password", confirmPassword: "password" });
  const [password, setPassword] = useState("");

  const passwordRequirements = [
    { label: "At least 12 characters", isValid: password.length >= 12 },
    { label: "At least one uppercase letter (A-Z)", isValid: /[A-Z]/.test(password) },
    { label: "At least one lowercase letter (a-z)", isValid: /[a-z]/.test(password) },
    { label: "At least one number (0-9)", isValid: /\d/.test(password) },
    { label: "At least one special character (! @ # $ %)", isValid: /[^A-Za-z0-9\s]/.test(password) },
  ];
  const isPasswordValid = passwordRequirements.every((requirement) => requirement.isValid);

  const getting_whitelable_domain = async () => {
    const currentURL = window.location.href;
    const urlObject = new URL(currentURL);
    const domain = urlObject.hostname;
    const payload = {
      domain: domain,
      token: token
    };
    const { response } = await Service.agency.getwhitelabel({
      payload: payload,
    });
    if (response) {
      setwhitelabel(response.data);
      setTokenStatus(response.token_status)
    }
  };

  useEffect(() => {
    getting_whitelable_domain();
  }, []);

  const updateMetaInfo = () => {
    const newFavicon = agencyData?.Customization?.chatapp_logo || maybeLogo;

    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/x-icon";
    link.href = newFavicon;

    const head = document.head || document.getElementsByTagName("head")[0];
    const existingFavicon = document.querySelector("link[rel*='icon']");

    if (existingFavicon) {
      head.removeChild(existingFavicon);
    }

    head.appendChild(link);
  };

  useEffect(() => {
    updateMetaInfo();
    document.body.style.background = "white";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const trimmedPassword = password.trim();
    const confirmPassword = e.target.confirmPassword.value.trim();
    if (!trimmedPassword) {
      setmessages("Please enter your password");
      setLoading(false);
      return false;
    }
    if (!confirmPassword) {
      setmessages("Please confirm your password");
      setLoading(false);
      return false;
    }
    if (!isPasswordValid) {
      setmessages("Password must meet all minimum requirements");
      setLoading(false);
      return false;
    }
    if (trimmedPassword !== confirmPassword) {
      setmessages("Passwords do not match");
      setLoading(false);
      return false;
    }

    const payload = {
      agency_id: whitelabel?._id,
      token: token,
      password: trimmedPassword,
    };

    try {
      const { response } = await Service.user.set_password({
        payload: payload,
      });
      if (response?.success) {
        setLoading(false);
        setmessages(response.message);

        setTimeout(() => {
          return navigate(`/auth/sign-in`);
        }, 3000);
      } else {
        setTokenStatus(false)
      }
    } catch (error) {
      console.log("Error", error);
      setmessages("An error occurred while creating your account");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="h-screen bg-white">
        <AuthTopBar />
        <div className="relative flex justify-center item-center h-[calc(100vh-64px)]">
          <div className="text-center m-auto w-[400px]">
            <h1 className="font-[600] text-[28px] mt-[20px] mb-4" style={{ fontFamily: "Inter" }}>Create your password</h1>

            <form onSubmit={handleSubmit} className="loginForm">
              <div className="relative mt-2.5">
                <input
                  type={fieldType.password}
                  placeholder="Password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="placeholder:font-[300] placeholder:text-[14px]"
                />
                <span
                  className="absolute top-1/2 -translate-y-1/2 right-4 cursor-pointer"
                  onClick={() => { setFieldType({ ...fieldType, password: fieldType.password === "password" ? "text" : "password" }) }}
                >
                  <Icons id={fieldType.password === "password" ? "eyeIcon" : "eyeCrossIcon"} />
                </span>
              </div>
              {password && (
                <div className="mt-3 px-1 text-left">
                  <p className="font-semibold text-sm text-[#1E1E1E]">
                    Your password must contain:
                  </p>
                  <div className="mt-2 space-y-1.5">
                    {passwordRequirements?.map((requirement) => (
                      <p
                        key={requirement.label}
                        className={`flex items-center gap-2 text-sm ${requirement.isValid ? "text-[#16A34A]" : "text-[#EF4444]"
                          }`}
                      >
                        <span
                          className="w-4 text-center font-semibold"
                          aria-hidden="true"
                        >
                          {requirement.isValid ? "✓" : "×"}
                        </span>
                        <span>{requirement.label}</span>
                      </p>
                    ))}
                  </div>
                </div>
              )}
              <div className="relative mt-2.5">
                <input
                  type={fieldType.confirmPassword}
                  placeholder="Re-enter Password"
                  name="confirmPassword"
                  className="placeholder:font-[300] placeholder:text-[14px]"
                />
                <span
                  className="absolute top-1/2 -translate-y-1/2 right-4 cursor-pointer"
                  onClick={() => { setFieldType({ ...fieldType, confirmPassword: fieldType.confirmPassword === "password" ? "text" : "password" }) }}
                >
                  <Icons id={fieldType.confirmPassword === "password" ? "eyeIcon" : "eyeCrossIcon"} />
                </span>
              </div>
              {!tokenStatus && (
                <p className="mb-5 text-[14px] font-[300]" style={{ color: 'red', fontFamily: "Inter" }}>
                  Invalid or expired link. Reset create password{" "}
                  <span
                    className="underline cursor-pointer"
                    onClick={() => setOpenForgetModel(true)}
                  >
                    here
                  </span>
                  .
                </p>
              )}

              {messages !== "" && <p className="success-alert mb-5 text-[14px] font-[300]">{messages}</p>}
              <div className="mt-5" style={{ textAlign: "right" }}>
                <button
                  className={`w-full text-center py-3 text-[16px] rounded font-[600] bg-black text-white !border-black border`}
                  variant="gradient"
                  color="info"
                  size="large"
                  type="submit"
                  disabled={loading}
                  style={{ fontFamily: "Inter" }}
                >
                  {loading ? "Loading..." : "Create Password"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ForgetModel
        isModalOpen={openForgetModel}
        justCloseIt={() => setOpenForgetModel(false)}
      />
    </>
  );
};

export default SetPassword;
